/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
	MutationFunction,
	QueryClient,
	UseMutationOptions,
	UseMutationResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	CreateCheckoutRequest,
	CreateCheckoutResponse,
	PraetoidError,
	SubmitCheckoutParams,
	SubmitCheckoutRequest,
	SubmitCheckoutResponse
} from '../models';

/**
 * Creates a new checkout session with a signed URL for content submission
 * @summary Create checkout session
 */
export const createCheckout = (createCheckoutRequest: CreateCheckoutRequest) => {
	return customInstance<CreateCheckoutResponse>({
		url: `/checkouts`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: createCheckoutRequest
	});
};

export const getCreateCheckoutMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createCheckout>>,
		TError,
		{ data: CreateCheckoutRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createCheckout>>,
	TError,
	{ data: CreateCheckoutRequest },
	TContext
> => {
	const mutationKey = ['createCheckout'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createCheckout>>,
		{ data: CreateCheckoutRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createCheckout(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof createCheckout>>>;
export type CreateCheckoutMutationBody = CreateCheckoutRequest;
export type CreateCheckoutMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create checkout session
 */
export const useCreateCheckout = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createCheckout>>,
			TError,
			{ data: CreateCheckoutRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof createCheckout>>,
	TError,
	{ data: CreateCheckoutRequest },
	TContext
> => {
	return useMutation(getCreateCheckoutMutationOptions(options), queryClient);
};
/**
 * Submit multimodal content via signed URL for moderation
 * @summary Submit content to checkout
 */
export const submitCheckout = (
	token: string,
	params: SubmitCheckoutParams,
	submitCheckoutRequest?: SubmitCheckoutRequest
) => {
	const formData = new FormData();
	if (submitCheckoutRequest?.['images[]'] !== undefined) {
		submitCheckoutRequest?.['images[]'].forEach((value) => formData.append(`images[]`, value));
	}
	if (submitCheckoutRequest?.metadata !== undefined) {
		formData.append(`metadata`, JSON.stringify(submitCheckoutRequest.metadata));
	}
	if (submitCheckoutRequest?.['texts[]'] !== undefined) {
		submitCheckoutRequest?.['texts[]'].forEach((value) => formData.append(`texts[]`, value));
	}

	return customInstance<SubmitCheckoutResponse>({
		url: `/checkouts/${token}`,
		method: 'POST',
		headers: { 'Content-Type': 'multipart/form-data' },
		data: formData,
		params
	});
};

export const getSubmitCheckoutMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof submitCheckout>>,
		TError,
		{ token: string; params: SubmitCheckoutParams; data?: SubmitCheckoutRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof submitCheckout>>,
	TError,
	{ token: string; params: SubmitCheckoutParams; data?: SubmitCheckoutRequest },
	TContext
> => {
	const mutationKey = ['submitCheckout'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof submitCheckout>>,
		{ token: string; params: SubmitCheckoutParams; data?: SubmitCheckoutRequest }
	> = (props) => {
		const { token, params, data } = props ?? {};

		return submitCheckout(token, params, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type SubmitCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof submitCheckout>>>;
export type SubmitCheckoutMutationBody = SubmitCheckoutRequest | undefined;
export type SubmitCheckoutMutationError = ErrorType<PraetoidError>;

/**
 * @summary Submit content to checkout
 */
export const useSubmitCheckout = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof submitCheckout>>,
			TError,
			{ token: string; params: SubmitCheckoutParams; data?: SubmitCheckoutRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof submitCheckout>>,
	TError,
	{ token: string; params: SubmitCheckoutParams; data?: SubmitCheckoutRequest },
	TContext
> => {
	return useMutation(getSubmitCheckoutMutationOptions(options), queryClient);
};
